<template>
    <div class="planningAdjustment">
        <div class="content">
            <PlanReport title="最新规划内容" :plan="plan" :version="version"></PlanReport>
            <ul class="lisPage">
                <li v-for="(item,index) in pageList" :key="index" @click="changePage(item.name)" :class="nowPage==item.name?'active': ''">{{item.title}}</li>
            </ul>
            <keep-alive>
                <component
                    :is="nowPage" class="tabs_content"
                    :goalPlanObj="goalPlanObj"
                    :careerMajorObj="careerMajorObj"
                    :furtherWayObj="furtherWayObj"
                    :chooseSubjectObj="chooseSubjectObj"                 
                >
                </component>
            </keep-alive>
        </div>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <!--<Button @handleClick="submitForm('ruleForm',true)" :type="'btnGray'" :name="预览" ></Button>-->
            <Button @handleClick="goSubmit" :type="'btnBlue'" name="确认调整" ></Button>
        </div>
        <InterviewPopup :interviewRecord="interviewRecord"   :isInputReadOnly="true"    v-on:closePop="()=>isShowPop=false" v-show="isShowPop"></InterviewPopup>
    </div>
</template>
<script>

import PlanReport from '@/components/consultant/planningContent/PlanReport.vue'
import CareerMajorList from '@/components/consultant/planningContent/CareerMajorList.vue'
import GoalPlanning from '@/components/consultant/planningContent/GoalPlanning.vue'
import WayPlanning from '@/components/consultant/planningContent/WayPlanning.vue'
import SubjectPlanning from '@/components/consultant/planningContent/SubjectPlanning.vue'
import InterviewPopup from '@/components/consultant/InterviewPopup.vue'
import Button from '@/components/Button.vue'
export default {
    name: "planningAdjustment",
    components: {
        PlanReport,
        CareerMajorList,
        GoalPlanning,
        WayPlanning,
        SubjectPlanning,
        InterviewPopup,
        Button
    },
    data() {
        return {   
               
            isShowPop: true,
            nowPage: 'CareerMajorList',
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            oldId: this.$route.query.id,
            interviewRecord: {
                category: '2',//类别：1首次访谈 2规划内容 3 计划执行
                interviewTime: '',//访谈时间
                interviewNum: '',//第几次访谈
                interviewTheme: '规划内容'+ this.$route.query.num +'次调整',//访谈主题
            },//访谈记录
            plan:{},
            pageList:[
                { title: '专、职业目标调整',name: 'CareerMajorList' },
                { title: '院校、分数目标调整',name: 'GoalPlanning' },
                { title: '路径、目标调整',name: 'WayPlanning' },
                { title: '选科调整',name: 'SubjectPlanning' },
            ],
            careerMajorObj: {
                careerDataIndex: '0',
                targetCareerField: '',
                targetCareer: [],
                targetSubject: [],
                targetRemark: '',
                // targetCareerZhuanye:[], //专业选项集合
            },           
            goalPlanObj: {
                universityScore: [],
                universityIdName:[],
                score: '',
                rank: '',
                remarkLog: '',//咨詢記錄
            },
            furtherWayObj: {
                furtherWay: '',//升学路径
                furtherWayNeed:'',//路径条件
                furtherWayNeedOther:'',//其他条件
                furtherWayRemark: '',//咨询总结
            },
            chooseSubjectObj: {
                chooseSubjectName: [],//選科方案
                chooseSubjectRequire: [],//目标院校对目标专业的选科要求
                chooseSubjectRemark: '',//选科调整记录
                hadCheckedList:[],
            },
            version:''
        }
    },
    computed:{

    },
    watch: {
        targetCareerField() {
            console.log(this.targetCareerField)
        },
        
        

    },
    methods:{
       
        changePage(page) {
            this.nowPage=page;
        },
        getPlanById(){
            let studentId = this.studentId;
            let id = this.$route.query.id;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getPlanById, {
                studentId: studentId,
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.plan = data.data;
                    this.version = data.data.version;
                }
            })
        },
        goSubmit() {   
            
           
            let oldId = this.oldId;
            let studentId = this.studentId;
            let interviewRecord = this.interviewRecord;
            let careerMajorObj = this.careerMajorObj;
            let goalPlanObj = this.goalPlanObj;
            let furtherWayObj = this.furtherWayObj;
            let chooseSubjectObj = this.chooseSubjectObj;
            
            
            // interviewRecord={
            //     category: interviewRecordObj.category,
            //     interviewTime: interviewRecordObj.interviewTime,//访谈时间
            //     interview_num: interviewRecordObj.interviewTime,//第几次访谈
            //     interview_theme: interviewRecordObj.interviewTheme
            // }

            if(!(careerMajorObj.targetCareer.length||careerMajorObj.targetSubject)) {
                careerMajorObj.targetCareerField = '';
            }

            if(this.$route.query.num == 0){
                if(careerMajorObj.targetCareer.length==0||careerMajorObj.targetSubject.length==0||careerMajorObj.targetCareerField==''||careerMajorObj.professional==''){
                this.$message.error('请选择完全信息')  
                return false            
                }
            }

            // console.log(chooseSubjectObj.hadCheckedList,'chooseSubjectObj')
           
            
            let plan ={               
                targetCareerField: careerMajorObj.targetCareerField,
                targetCareer: careerMajorObj.targetCareer,
                targetSubject: careerMajorObj.targetSubject,
                targetRemark: careerMajorObj.targetRemark,
                universityScore: goalPlanObj.universityScore,
                universityIdName:goalPlanObj.universityIdName,
                score: goalPlanObj.score,
                rank: goalPlanObj.rank,
                remarkLog: goalPlanObj.remarkLog,//咨詢記錄
                furtherWay: furtherWayObj.furtherWay,//升学路径
                furtherWayNeed:furtherWayObj.furtherWayNeed,//路径条件
                furtherWayNeedOther:furtherWayObj.furtherWayNeedOther,//其他条件
                furtherWayRemark: furtherWayObj.furtherWayRemark,//咨询总结
                chooseSubjectName: chooseSubjectObj.chooseSubjectName.length > 0 ? chooseSubjectObj.chooseSubjectName : chooseSubjectObj.hadCheckedList,//選科方案
                chooseSubjectRequire: chooseSubjectObj.chooseSubjectRequire,//目标院校对目标专业的选科要求
                chooseSubjectRemark: chooseSubjectObj.chooseSubjectRemark,//选科调整记录              
                // 新增加的选择项 
                 professional:careerMajorObj.professional==undefined?'':careerMajorObj.professional 
                //  targetSubject           
            }
            if(this.version == 1){

                delete plan.professional
            }
            // console.log(careerMajorObj.professional,'目标类')
            // console.log(interviewRecord,plan)
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.adjustPlan, {
                lastId: oldId,
                studentId: studentId,
                interviewRecord: interviewRecord,
                plan:plan
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.$router.push('/consultant/minestudent/main/planningContent/recordList');
                }
            })
        }
    },
    created() {
        this.getPlanById();
     
    },
    mounted(){
       
    }
}
</script>
<style scoped lang="less">
.planningAdjustment {
    .content {
        padding: 30px;
        background-color: #fff;
    }
    .lisPage {
        padding: 0 100px;
        border-bottom: 1px solid #D9D9D9;
        display: flex;
        justify-content: space-between;
        height: 45px;
        box-sizing: border-box;
        li {
            line-height: 45px;
            font-size: 18px;
            font-weight: 500;
            color: #434141;
            box-sizing: border-box;
            cursor: pointer;
        }
        .active {
            color: #3D90F6;
            border-bottom: 3px solid #3D90F6;
        }
    }

}
</style>